import Vue from 'vue'  //独立router需要引入vue
import VueRouter from 'vue-router' //引入router
import NProgress from "nprogress"; //进入进度条


const routerReplace = VueRouter.prototype.replace

VueRouter.prototype.replace = function replace(location) {
    return routerReplace.call(this, location).catch(error => error)
}

//push
const routerPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}

Vue.use(VueRouter)  //将router注册到vue对象种

const routes = [
  {path:'/', redirect:'/questionnaire/list'},
  {
    path: '/',
    name: 'Main',
    component: () => import("./views/Main.vue"), //引入后台主模板
    children: [  //后台右侧显示区
      {path:'/questionnaire/list', name: "QuestionnaireList", component: () => import("./views/QuestionnaireList.vue")},  //问卷列表
      {path:'/questionnaire/edit', name: "QuestionnaireEdit", component: () => import("./views/QuestionnaireEdit.vue")},  //问卷编辑
      {path:'/questionnaire/statistics', name: "QuestionnaiStatistics", component: () => import("./views/QuestionnaiStatistics.vue")},  //问卷数据统计
      {path:'/questionnaire/question_list', name: "QuestionList", component: () => import("./views/QuestionList.vue")},  //问卷统计-》题目列表
      {path:'/question_bank/list', name: "QuestionBank", component: () => import("./views/QuestionBank.vue")},  //题库
      {path:'/unit/list', name: "UnitList", component: () => import("./views/UnitList.vue")},  //题库
      {path:'/submission/list', name: "SubmissionList", component: () => import("./views/SubmissionList.vue")},  //试卷提交列表
      {path:'/submission/details', name: "SubmissionDetails", component: () => import("./views/SubmissionDetails.vue")},  //问卷提交详情
      {path:'/feedback/list', name: "FeedbackList", component: () => import("./views/FeedbackList.vue")},  //反馈列表
      {path:'/feedback/details', name: "FeedbackDetails", component: () => import("./views/FeedbackDetails.vue")},  //反馈详情
      {path:'/audit_queue/list', name: "AuditQueue", component: () => import("./views/AuditQueue.vue")},  //待审核问卷
      {path:'/audit_queue/details', name: "AuditQueueDetails", component: () => import("./views/AuditQueueDetails.vue")},
      // {path:'/question_bank/edit', name: "QuestionBankEdit", component: () => import("./views/QuestionBankEdit.vue")},  //题库编辑


 //问卷提交详情 -》 问卷详情
 //待审核问卷详情 -》 问卷详情





      // {path:'/evnt_mgt', name:'EvntMgtList',  component: () => import("./views/EvntMgtList.vue")},  //赛事管理
      // {path:'/evnt_mgt/create', name:'EvntMgtEdit',  component: () => import("./views/EvntMgtEdit.vue")},  //赛事管理新增
      // {path:'/evnt_mgt/edit', name:'EvntMgtEdit',  component: () => import("./views/EvntMgtEdit.vue") },  //赛事管理修改
      
      
      // {path:'/evnt_mgt/reg_details', name:'EvntRegDetails',  component: () => import("./views/EvntRegDetails.vue")},  //赛事报名列表
      // {path:'/evnt_mgt/reg_user_details', name:'EvntRegUserDetails',  component: () => import("./views/EvntRegUserDetails.vue")},  //赛事报名用户详情
      
      // //{path:'/evnt_mgt/item_setting', name:'EvntMgtItemSetting',  component: () => import("./views/EvntMgtItemSetting.vue")},  //项目设置(跳过)

      // {path:'/evnt_mgt/reg_setting/list', name:'EvntMgtRegSettingList',  component: () => import("./views/EvntMgtRegSettingList.vue"),  props: true },  //报名设置
      // {path:'/evnt_mgt/reg_setting/create', name:'EvntMgtRegSettingEdit',  component: () => import("./views/EvntMgtRegSettingEdit.vue")},  //报名设置新增
      // {path:'/evnt_mgt/reg_setting/edit', name:'EvntMgtRegSettingEdit',  component: () => import("./views/EvntMgtRegSettingEdit.vue"),  props: true },  //报名设置修改
      // {path:'/evnt_mgt/reg_setting/import', name:'EvntMgtRegSettingImport',  component: () => import("./views/EvntMgtRegSettingImport.vue"),  props: true },  //报名导入

      // {path:'/evnt_mgt/group_code', name:'EvntGroupCode',  component: () => import("./views/EvntGroupCode.vue"),  props: true },  //团报邀请码列表
      // {path:'/evnt_mgt/group_list', name:'EvntGroupList',  component: () => import("./views/EvntGroupList.vue"),  props: true },  //团报列表

      // {path:'/evnt_mgt/reg_fields', name:'EvntMgtRegFields',  component: () => import("./views/EvntMgtRegFields.vue"),  props: true },  //报名字段设置
      // {path:'/evnt_mgt/reg_code', name:'EvntMgtRegCode',  component: () => import("./views/EvntMgtRegCode.vue"),  props: true },  //报名字段设置
      
      // {path:'/type/list', name:'TypeList',  component: () => import("./views/TypeList.vue") },  //类型管理
      // {path:'/type/item_list', name:'TypeItemList',  component: () => import("./views/TypeItemList.vue") },  //查看项目

      // {path:'/item/list', name:'ItemList',  component: () => import("./views/ItemList.vue") },  //项目管理
      // {path:'/city/list', name:'CityList',  component: () => import("./views/CityList.vue") },  //城市管理
      // {path:'/order/statistics', name:'OrderStatistics',  component: () => import("./views/OrderStatistics.vue") },  //退款管理
      // {path:'/runnerTeams/list', name:'RunnerTeamsList',  component: () => import("./views/RunnerTeamsList.vue") },  //跑团管理

      // {path:'/banner/list', name:'BannerList',  component: () => import("./views/BannerList.vue") },  //轮播图管理
      // {path:'/config', name:'Config',  component: () => import("./views/Config.vue") },  //基本配置
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import("./views/Login.vue"),
    meta: { isPublic: true }
  },
  {
    path: "*",
    name: "NotFound",
    component: () => import("./views/NotFound.vue"),
  },
]

const router = new VueRouter({
  mode: 'hash',
  // base: '/admin/',
  // base: process.env.BASE_URL,
  routes,
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active'
})

//路由监听
router.beforeEach((to, from, next) => {
  if (!to.meta.isPublic && !localStorage.getItem('token')) { //不是公开访问的页面 并且 无token
    Vue.prototype.$message({ type: "error", message: "请先登录" });
    return next('/login')
  }

  // 如果有token并且是公共页面，重定向到/user页面
  // if (to.meta.isPublic && localStorage.getItem('token')) {
  //   return next('/stf_mgt');
  // }

  NProgress.start(); //进度条开始
  next()
})

router.afterEach(() => {
  NProgress.done();  //进度条完成
})

// router.$addRoutes = (routes) => {
//   // 自定义一个$addRoutes的方法
//   // 通过新建一个全新的 Router，然后将新的 Router.matcher 赋给当前页面的管理 Router，以达到更新路由配置的目的。自定义的$addRoutes，就是实现这个功能
//   router.matcher = new VueRouter().matcher;
//   router.addRoutes(routes);
// };


export default router
